'use client';

import Link from 'next/link';
import { useRouter, useSearchParams } from 'next/navigation';
import { Button } from 'antd';
import NotFoundIcon from '/public/404.svg';
import { IconWrapper } from '@/components/ui/icon-wrapper';
import { useI18n } from '@/hooks/use-i18n';

export default function NotFound() {
  const { t } = useI18n(['error', 'common']);
  // 获取 searchParams
  const searchParams = useSearchParams();
  const msg = searchParams.get('msg');
  const router = useRouter();

  return (
    <div className="w-full h-[100vh] flex flex-col items-center justify-center gap-4">
      <IconWrapper icon={NotFoundIcon} size={208} className="h-[95px]" />
      <div>{msg || t('error:notFound.title')}</div>
      <Button
        type="primary"
        size="large"
        className="h-10 !text-[13px]"
        onClick={() => {
          router.push('/');
        }}
      >
        {t('common:backToHome')}
      </Button>
    </div>
  );
}
